/**
 * @module Banner | Heading - Editable
 * @description
 */
import BannerHeadline from '@/blocks/Banners/BannerHeadline';
import Tooltip from '@/blocks/Tooltip';
import setHtml from '@/js/utils/setHtml';
import { useMonarchSlotContext } from '@redventures/cohesion-utils-react';
import { bannerHeadingDefaults } from './default';
/**
 * @function Component
 * @description
 */
const Component = ( ) => {
  const { data = {} } = useMonarchSlotContext( {
    default: bannerHeadingDefaults
  } );

  const {
    heading,
    subheading,
    legalHash,
    tooltip,
    theme,
    isCentered,
    cta
  } = data ?? {};

  return (
    <BannerHeadline
      title={ heading && <span { ...setHtml( heading ) }></span> }
      subtitle={
          subheading && (
          <>
            <span { ...setHtml( subheading ) }></span>{' '}
            {legalHash && (
              <span data-legal={ legalHash }></span>
            )}
            {tooltip && <Tooltip disclosure={ tooltip } />}
          </>
          )
      }
      theme={ theme }
      isCentered={ isCentered }
      ctaCopy={ cta?.copy }
      ctaUrl={ cta?.url }
    />
  );
};

export default Component;
